/**
 * Display-only price maths, carried over from the truck: everything in cents
 * (integers) because 0.1 + 0.2 is not 0.3. A backend, once there is one,
 * recomputes every total from its own data and wins any disagreement.
 */

export function toCents(value: string | number): number {
  return Math.round(Number(value) * 100);
}

export function formatPrice(cents: number, locale = "de-DE"): string {
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 2,
  }).format(cents / 100);
}

export function formatPriceDelta(cents: number, locale = "de-DE"): string {
  if (cents === 0) return "";
  const sign = cents > 0 ? "+" : "−";
  return `${sign}${formatPrice(Math.abs(cents), locale)}`;
}
